import React, {Component} from 'react';
import { Row, Col, ButtonToolbar, ToggleButton, ToggleButtonGroup, Glyphicon } from 'react-bootstrap';
import {PRODUCT_PAGE_SELECT_NEW_PRODUCT} from '../../../reducers/productPageReducer';
import GroupHeader from './group-header';

class CategoriesFilter extends Component {
  render() {
    const {
      categories, filterBox, onCategoryFilterChange, onNewProductFilterChange, fetchingProducts
    } = this.props;

    if (!categories) {
      return (<div></div>);
    }

    const categoryButtons = categories.map(category => (
      <ToggleButton
        key={`category-${category.id}`}
        value={category.id}
        disabled={fetchingProducts}
      >
        <div>
          <img alt={category.name} className="filter-image" src={category.links.photo}/>
          <div className="filter-name">
            {category.name}
          </div>
        </div>
      </ToggleButton>
    ));

    return (
      <Row className="categories-filter">
        <Col lg={12}>
          <GroupHeader>Categories</GroupHeader>
          <ButtonToolbar>
            <ToggleButtonGroup
              type="checkbox"
              onChange={onCategoryFilterChange}
              value={filterBox.categories}
            >
              {categoryButtons}
            </ToggleButtonGroup>
            <ToggleButtonGroup
              type="checkbox"
              onChange={onNewProductFilterChange}
              value={filterBox.specialNew ? [PRODUCT_PAGE_SELECT_NEW_PRODUCT] : []}
            >
              <ToggleButton
                value={PRODUCT_PAGE_SELECT_NEW_PRODUCT}
                disabled={fetchingProducts}
              >
                <div className="special-icon">
                  <Glyphicon glyph="tags"/>
                </div>
                <div className="filter-name">
                  New
                </div>
              </ToggleButton>
            </ToggleButtonGroup>
          </ButtonToolbar>
        </Col>
      </Row>
    );
  }
}

export default CategoriesFilter;



// WEBPACK FOOTER //
// ./src/components/product-page/filters/categories-filter.jsx